<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- begin                                                                         -->
    <v-card align="center" justify="center" class="box">
      <!-- <v-card-title> Add Visitor </v-card-title> -->
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Add Visitor</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-icon @click="onLoad" title="Reload list" dark color="yellow">mdi-reload</v-icon>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-img v-if="logo != null" style="width: 250px; height: 155px" class="shrink mr-2" contain
              :src="logo"></v-img>
          </v-col>
          <!-- <v-col cols="12" v-if="qrcode==true">
               <qrcode-vue v-if="visitor_mobileno!=null" :value="visitor_mobileno" :size="100" level="H" />
            </v-col> -->
        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="4"></v-col>
          <v-col cols="12" md="3" sm="3">
            <v-text-field v-model="visitor_mobileno" append-icon="mdi-cellphone-basic" label="*Mobile No." single-line
              dense hint="Enter your mobile No Only 10 Digits" persistent-hint id="mobilenumber"></v-text-field>
            <span id="messages"> </span>
            <div v-if="mob_error == true" class="alert">{{ mob_error1 }}</div>
          </v-col>
          <v-col cols="12" md="1" sm="1">
            <v-btn color="info" @click="getVisitor">Fetch</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="4"></v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field v-model="visitor_name" append-icon="mdi-account" label="*Name" dense single-line
              hint="Enter your name" persistent-hint :rules="textRule" @keyup="validName"></v-text-field>
            <!-- <div> -->
            <!-- <input type="text" @keyup="checkValue" v-model="visitor_name" /> -->
            <div v-if="name_error == true" class="alert">{{ error }}</div>

            <!-- </div> -->
          </v-col>

        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="4"></v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field v-model="visitor_email" append-icon="mdi-email" label="Email" dense single-line
              hint="Enter your Email" persistent-hint :rules="[rules.email]"></v-text-field>
            <!-- <div> -->
            <!-- <input type="text" @keyup="checkValue" v-model="visitor_name" /> -->


            <!-- </div> -->
          </v-col>

        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="4"></v-col>
          <v-col cols="12" md="4" sm="4">
            <v-textarea outlined name="input-7-4" hint="Enter your address" persistent-hint
              append-icon="mdi-city-variant-outline" v-model="visitor_address" label="Address"></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="4"></v-col>
          <v-col cols="12" md="4" sm="4" v-if="name_error == false && mob_error == false">
            <v-btn color="info" :disabled="isSaveButtonDisabled" @click="addVisitor()">{{ save_edit }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card align="center" justify="center" class="box">
      <!-- <v-card-title> Add Visitor </v-card-title> -->
      <!-- <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Add Visitor</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar> -->
      <!-- excel export btn code -->
      <v-row dense>
        <v-col cols="12" sm="4" md="4"></v-col>
        <!-- <v-col cols="12" sm="4" md="4">
          <v-btn
            color="success"
            outlined
            rounded
            v-if="visitors_list.length != 0"
          >
            <download-excel
              class="mr-2 pb-3 pt-2"
              :data="visitors_list"
              :fields="table_fields"
              worksheet="AdminAddedVisitors"
              name="AdminAddedVisitors.xls"
            >
              <v-icon dark>mdi-file-excel</v-icon> Export
            </download-excel>
          </v-btn>
        </v-col> -->
        <v-col sm="4" md="4" cols="12">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
      </v-row>
      <!-- excel export btn code end -->
      <v-data-table :headers="headers" :items="visitors_list" :search="search" class="dataTable">
        <template v-slot:top>
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Add Visitor</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>

        <template v-slot:[`item.edit`]="{ item }">
          <div>
            <v-avatar size="25" class="edit-avatar">
              <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
            </v-avatar>
          </div>
        </template>
        <template v-slot:[`item.delete`]="{ item }">
          <div>
            <v-avatar size="35">
              <v-icon class="mr-4 v-icon-size" color="red" @click="deletePlanData(item)">mdi-trash-can</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>
      <!-- <v-card-text> Visitor List {{ visitors_list }} </v-card-text> -->
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
// import QrcodeVue from 'qrcode.vue'
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  // components: {
  //   QrcodeVue,
  // },
  data: () => ({
    rules: {
      required: value => !!value || 'Required.',
      counter: value => value.length <= 20 || 'Max 20 characters',

    },
    // extraBreadcrumbItems: [
     

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    textRule: [(v) => !!v || "Field is required"],
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    ///////////////////////////////////////////////
    logo: null,
    proceed_flag: false,
    visitor_address: null,
    visitor_name: null,
    visitor_email: null,
    visitor_mobileno: null,
    // visitor_present: false,
    ///////////////////
    visitors_list: [],
    name_error: false,
    mob_error: false,
    save_edit: "Add Visitor",
    search: "",
    headers: [
      { text: "Sr. No", value: "srno" },
      { text: "Visitor Mobile Number", value: "visitor_mobile" },
      { text: "Visitor Name", value: "visitor_name" },
      { text: "Visitor Email", value: "visitor_email" },

      { text: "Address", value: "visitor_address" },

      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" },
    ],
    table_fields: {
      "Sr. No": "visitor_id",
      "Visitor Mobile Number": "visitor_mobile",
      "Visitor Name": "vistor_name",
      Address: "visitor_address",
    },
  }),

  mounted() {
    this.onLoad();
  },
  computed: {
    isSaveButtonDisabled() {
      return !(this.visitor_name && this.visitor_mobileno);
    },
  },
  methods: {
    //  mobile no. validation

    validName() {
      this.validMob();
      if (/[^a-zA-Z\s]/.test(this.visitor_name)) {
        this.error = "Input value contains other syantax.";
        this.showSnackbar("red", "Input value contains other syantax.");
        // alert("Input value contains other syantax");
        this.name_error = true;
        this.overlay = false;
      } else {
        this.name_error = false;
        this.error = "";
      }
    },
    validEmail(email) {
      //alert("in valid")
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(email)) {
        // alert("Please Check Your email id");
        return true;
      }
      return false;
    },
    validMob() {
      var a = document.getElementById("mobilenumber").value;

      if (a.length < 10 || a.length > 10 || isNaN(a) || a == "") {
        this.mob_error1 = "Please Enter Valid Number";

        this.showSnackbar("red", "Please Enter Valid Number");
        this.mob_error = true;
        return false;
      } else {
        this.mob_error = false;
      }
    },

    hasWhiteSpace(s) {
      var status = false;
      var reWhiteSpace = new RegExp(/^\s+$/);

      // Check for white space
      if (reWhiteSpace.test(s)) {
        // alert("Please Check Your Fields For Spaces");
        return true;
      }
      return false;
    },

    // validation code end

    reset() {
      this.save_edit = "Add Visitor";
      //   this.edit_io_id = null;
      this.visitor_name = "";
      this.visitor_email = "";
      this.visitor_mobileno = "";
      this.visitor_address = "";
    },

    editItem(item) {
      this.$vuetify.goTo(0); // for scrolling up
      // this.$vuetify.goTo(this.$refs.selectedCard); // for scrolling up

      this.save_edit = "Edit";
      this.visitor_name = item.visitor_name;
      this.visitor_email = item.visitor_email;
      this.visitor_mobileno = item.visitor_mobile;
      this.visitor_address = item.visitor_address;

      //this.date_1 = item.iodate
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    ///////////////////////////
    onLoad() {
      this.save_edit = "Add Visitor";
      this.overlay = true;
      axios
        .post("/visitorManagement/getAllVisitors")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.logo = res.data.logo;
            this.visitors_list = res.data.visitors_list;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    deletePlanData(item) {
      const formdata = {
        visitor_id: item.visitor_id,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/deleteAddVisitor", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.showSnackbar("green", res.data.snackbar);
            this.reset();
            this.onLoad()
          } else {
            //  this.qrcode = false
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          // this.qrcode = false
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    addVisitor() {
      //validation on mobileno and name // mandatory
      //alert(this.save_edit)
      this.validName();
      this.validMob();
      if (this.hasWhiteSpace(this.visitor_name) || this.visitor_name == null) {
        this.showSnackbar("#b71c1c", "Please Enter Name");
        return;
      }
      if (this.hasWhiteSpace(this.visitor_email)) {
        this.showSnackbar("#b71c1c", "Please Enter Email ");
        return
      }
      if (this.visitor_email) {

        if (!this.validEmail(this.visitor_email)) {
          this.showSnackbar("#b71c1c", "Please Enter Valid Email");
          return
        }
      }

      // if (/[^a-zA-Z\s]/.test(this.visitor_name)) {
      //   this.error = "Input value contains other syantax.";
      //   this.showSnackbar("red", "Input value contains other syantax.");
      //   alert("Input value contains other syantax");
      // } else {
      //   this.error = "";
      // }
      const formdata = {
        visitor_address: this.visitor_address,
        visitor_name: this.visitor_name,
        visitor_email: this.visitor_email,
        visitor_mobileno: this.visitor_mobileno,
        save_edit: this.save_edit,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/adminAddVisitor", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            if (this.save_edit != "Edit")
              this.visitors_list.push(res.data.visitor);
            // this.qrcode = true
            this.showSnackbar("green", res.data.snackbar);
            this.reset();
            this.onLoad()
          } else {
            //  this.qrcode = false
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          // this.qrcode = false
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    getVisitor() {
      //validation on mobileno and name // mandatory
      this.validMob();
      // var a = document.getElementById("mobilenumber").value;

      // if (a.length < 10 || a.length > 10 || isNaN(a) || a == "") {
      //   this.showSnackbar("red", "Please Enter Valid Number");
      //   this.mob_error = true;
      //   return false;
      // }
      this.visitor_address = ""
      this.visitor_name = ""
      this.visitor_email = ""
      const formdata = {
        visitor_mobileno: this.visitor_mobileno,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/adminGetVisitor", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            // this.visitor_present = true;
            this.visitor_address = res.data.visitor_address;
            this.visitor_name = res.data.visitor_name;
            this.visitor_email = res.data.visitor_email;
            //  this.qrcode = true
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            //  this.qrcode = false
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          // this.qrcode = false
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
  },
};
</script>

<style scoped>
.alert {
  /* padding: 5px 10px; */
  /* border: 1px solid #ff72728a; */
  display: inline-block;
  color: #f30808;
  /* border-radius: 4px; */
}
</style>